import { Injectable } from '@angular/core'
import { EnvironmentService } from 'framework/environment/environment.service'

interface BannerDetails {
    color: 'purple' | 'black' | 'red' | 'blue' | 'green'
    mainContent: string
    sidebarContent: string
}

@Injectable({
    providedIn: 'root',
})
export class ActionBannerService {
    constructor(private environmentService: EnvironmentService) {}

    retrieveBannerDetails(): BannerDetails {
        const { environment } = this.environmentService

        return {
            color: environment?.actionBanner?.color || 'purple',
            mainContent: environment?.actionBanner?.mainContent || '',
            sidebarContent: environment?.actionBanner?.sidebarContent || '',
        }
    }
}
